import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import URL from '../../../constants/url';

function useQuery() {
  const { search } = useLocation();
  return new URLSearchParams(search);
}

const PayResult = () => {

    const user = JSON.parse(sessionStorage.getItem("loginUser")) || undefined;

    const navigate = useNavigate();

    const query = useQuery();
    const status = query.get('status');  // success / fail
    const resCd = query.get('resCd');
    const shopOrderNo = query.get('shopOrderNo');
    const telmdcApplId = query.get('telmdcApplId');
    const telmdcSchdulId = query.get('telmdcSchdulId');

    const handleBackToCareplus = () => {


        navigate(URL.CONTACTLESS_DETAIL, { state: {
                telmdcApplId: telmdcApplId
            , telmdcSchdulId: telmdcSchdulId
        }});

        /*  메인으로가기..
        navigate(URL.CONTACTLESS_MAIN, { state: {
                telmdcApplId: telmdcApplId
            }});
        */
    }

    useEffect(() => {
      // 팝업에서 열렸다면, 부모창에게 알려주고 닫아도 됨 (옵션)
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(
          { type: 'EASYPAY_RESULT', status, resCd, shopOrderNo },
          '*'
        );
        // window.close();  // 자동으로 팝업 닫고 싶으면 주석 해제
      }
    }, [status, resCd, shopOrderNo]);

    return (
      <div style={{ padding: 20 }}>
        <h2>Payment Result</h2>
        {status === 'success' ? (
          <>
            <p>Thank you! Your payment was successfully processed.</p>
            <p>Order Number: {shopOrderNo}</p>
          </>
        ) : (
          <>
            <p>We’re sorry, but your payment could not be completed.</p>
            <p>Error Code: {resCd}</p>
          </>
        )}

        {
            user !== undefined &&
            <button className="submit-btn" onClick={handleBackToCareplus}>Back to Careplus!!</button>
        }
      </div>

    );
};

export default PayResult;
